export default {"src":"/_next/static/media/bottomCurved_bg_mobile2.4a4a21e1.svg","height":280,"width":375};